/**
 * @name urlToLowerCase
 * @description
 * Check url to detect UpperCase and do a redirection to LowerCase
 */
(function(){
  let { href, search } = window.location;

  // Making redirection to url lowercase
  if(href !== href.toLowerCase() && !search) window.location = url.toLowerCase();
})();